import { useEffect, useState } from 'react';

import { waitForClientInitialization } from './client';
import { isClientInitializedSync } from './flag-cache';

/**
 * Whether LaunchDarkly has settled, so `useFlag` returns the guest's real values rather than
 * the fallbacks. Also turns true when initialisation times out, since the fallbacks are then
 * the values the app runs with.
 */
export function useAreFlagsReady() {
  const [areFlagsReady, setAreFlagsReady] = useState(isClientInitializedSync);

  useEffect(() => {
    if (areFlagsReady) {
      return;
    }

    let cancelled = false;

    void waitForClientInitialization().then(() => {
      if (!cancelled) {
        setAreFlagsReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [areFlagsReady]);

  return areFlagsReady;
}
